import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import { TOPIC } from '../../constants'

import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
// eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/design-system-components/modal'
// eslint-disable-next-line import/no-internal-modules
import { ButtonGroup } from '@insided/deprecated-preact-components/design-system-components/button'
import Button from '@insided/control/uikit/Button'
import ToggleTrash from './ToggleTrash'

export interface ToggleTrashProps {
  contentType: ContentType
  topicId: number
  trashed: boolean
  onTrash: (trashed: boolean) => void
  onClose: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface ToggleTrashState {
  isLoading: boolean
  errorMessage?: string
}

class ToggleTrashModal extends PureComponent<ToggleTrashProps, ToggleTrashState> {
  constructor(props: ToggleTrashProps) {
    super(props)
    this.onToggleTrash = this.onToggleTrash.bind(this)
  }

  async onToggleTrash() {
    const { contentType, topicId, onTrash, trashed, onClose, onShowAlert } = this.props

    this.setState({ isLoading: true })

    try {
      await ToggleTrash({ contentType, topicId, trashed, onTrash, onShowAlert })
      onClose()
    } catch {
      onShowAlert?.('error')
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { onClose } = this.props
    const { isLoading } = this.state
    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title={`${TOPIC.ACTION}?`} />
        <ModalBody>
          <p>The topic will not be visible in community.</p>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              title={TOPIC.ACTION} variant='warning' onClick={this.onToggleTrash} isLoading={isLoading}
              data-qa='trash-topic' size='medium'
            />
            <Button title='Cancel' onClick={onClose} size='medium' />
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ToggleTrashModal
